import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/noDataDark.png';
const _withScopeId = n => (_pushScopeId("data-v-7491704c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container",
  "element-loading-text": "设备导入中..."
};
const _hoisted_2 = {
  class: "top-container searchTop"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  key: 0,
  class: "button-container"
};
const _hoisted_5 = {
  key: 0,
  class: "image-preview-container"
};
const _hoisted_6 = {
  key: 0,
  class: "no-image-tip"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 0,
  class: "dialog-footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "30px"
  }
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, " 仅支持xlsx格式的文件 ", -1));
const _hoisted_12 = {
  class: "dialog-footer"
};
const _hoisted_13 = {
  "element-loading-text": "加载中...",
  style: {
    "min-height": "400px"
  }
};
const _hoisted_14 = {
  key: 0,
  class: "video-container"
};
const _hoisted_15 = {
  class: "video-list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-video-camera"
}, null, -1));
const _hoisted_18 = {
  class: "video-player-wrapper"
};
const _hoisted_19 = {
  key: 1,
  class: "no-video-tip"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-video-camera-solid",
  style: {
    "font-size": "48px",
    "color": "#c0c4cc"
  }
}, null, -1));
import { lgasStationList, gasStationAdd, gasStationEdit, deleteGasStation, getStationVideos } from '@/api/station';
import { ref, unref, reactive, onMounted, computed, nextTick, onBeforeUnmount } from 'vue';
import Hls from 'hls.js';
import { downloadFlie } from '@/utils';
import { useStore } from 'vuex';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useRoute } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    let deviceForm = ref(null);
    let videoPlayer = ref(null);
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    const state = reactive({
      // 遮罩层
      loading: true,
      loading1: true,
      exportLoading: false,
      dialogVisible: false,
      videoDialogVisible: false,
      // 视频对话框显示状态
      videoLoading: false,
      // 视频加载状态
      videoList: [],
      // 视频列表
      currentVideoIndex: 0,
      // 当前播放视频索引
      hlsInstance: null,
      // hls.js播放器实例
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 场站台账表格数据
      roleList: [],
      // 弹出层标题
      title: '',
      uploadForm: {
        tenantId: null,
        fileList: []
      },
      uploadFormRules: {
        tenantId: [{
          required: true,
          message: '所属租户不能为空',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '上传文件不能为空',
          trigger: 'blur'
        }]
      },
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      isDetail: false,
      // 日期范围
      dateRange: [],
      point: null,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        stationCode: route.query.actNum || '',
        stationName: ''
      },
      // 表单参数
      form: {
        businessLicense: "",
        //营业执照
        commissioningDate: "",
        //投产日期	
        contactNumber: "",
        //联系方式	
        employeeNum: "",
        contactPerson: "",
        corporatePersion: "",
        //公司法人	
        latitude: "",
        //纬度		
        location: "",
        //地理位置
        longitude: "",
        //经度			
        operatorCompany: "",
        //运营公司	
        remark: "",
        //备注		
        tenantId: null,
        //	租户Id
        stationCode: "",
        //场站编码,场站编码长度为2-50个字符	
        stationName: "",
        //场站名称,场站名称长度为2-100个字符	
        imgUrl: [] //场站图片
      },
      // 表单校验
      rules: {
        stationCode: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 20,
          message: '场站编码最多20个字符',
          trigger: 'blur'
        }],
        stationName: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 30,
          message: '场站名称最多30个字符',
          trigger: 'blur'
        }],
        tenantId: [{
          required: true,
          message: '不能为空',
          trigger: 'change'
        }],
        operatorCompany: [{
          max: 30,
          message: '运营公司最多30个字符',
          trigger: 'blur'
        }],
        corporatePersion: [{
          max: 30,
          message: '公司法人最多30个字符',
          trigger: 'blur'
        }],
        contactPerson: [{
          max: 10,
          message: '联系人最多10个字符',
          trigger: 'blur'
        }],
        location: [{
          max: 30,
          message: '地理位置最多30个字符',
          trigger: 'blur'
        }],
        employeeNum: [{
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === '') {
              callback();
              return;
            }
            const numValue = Number(value);
            if (isNaN(numValue)) {
              callback(new Error('请输入有效的数字'));
              return;
            }
            if (numValue < 0) {
              callback(new Error('员工数量不能小于0'));
              return;
            }
            if (numValue > 100) {
              callback(new Error('员工数量不能大于100'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }],
        longitude: [
        // { required: true, message: "经度不能为空", trigger: "blur" },
        {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error("请输入有效的经度数值"));
              return;
            }
            // 检查范围：-180 到 180
            if (numValue < -180 || numValue > 180) {
              callback(new Error("经度范围应在-180到180之间"));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error("经度小数位最多20位"));
                return;
              }
            }
            callback();
          },
          trigger: "blur"
        }],
        latitude: [
        // { required: true, message: "纬度不能为空", trigger: "blur" },
        {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error("请输入有效的纬度数值"));
              return;
            }
            // 检查范围：-90 到 90
            if (numValue < -90 || numValue > 90) {
              callback(new Error("纬度范围应在-90到90之间"));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error("纬度小数位最多20位"));
                return;
              }
            }
            callback();
          },
          trigger: "blur"
        }]
      },
      saveLoading: false,
      searchFormData: [{
        prop: 'stationCode',
        label: '场站编码',
        placeholder: '场站编码',
        type: 'text',
        isSelect: false,
        span: 4
      }, {
        prop: 'stationName',
        label: '场站名称',
        placeholder: '场站名称',
        type: 'text',
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: '搜索',
        type: 'primary',
        icon: 'el-icon-search',
        class: 'btn-liquid',
        handle: () => handleQuery()
      }, {
        label: '重置',
        icon: 'el-icon-refresh',
        class: 'commonDarkBtn',
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: '新增',
        buttonStyle: 'primary',
        hasPermi: ['Station:page:add'],
        className: 'addBtn',
        buttonIcon: 'Plus',
        exp: item => handleAdd(item)
      },
      // {
      //   buttonName: '导入',
      //   buttonStyle: 'primary',
      //   className: 'importBtn',
      //   buttonIcon: 'Download',
      //   hasPermi: ['Hw:page:import'],
      //   exp: () => handleImport()
      // },
      {
        buttonName: '删除',
        buttonStyle: 'danger',
        hasPermi: ['Station:page:del'],
        className: 'deleteBtn',
        buttonIcon: 'Delete',
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }],
      deviceList: [],
      tableHeader: [{
        prop: 'stationCode',
        label: '场站编码'
      }, {
        prop: 'stationName',
        label: '场站名称'
      }, {
        prop: 'corporatePersion',
        label: '公司法人'
      }, {
        prop: 'contactNumber',
        label: '联系方式'
      }, {
        prop: 'operatorCompany',
        label: '运营公司'
      }, {
        prop: 'commissioningDate',
        label: '投产日期'
      }, {
        prop: 'businessLicense',
        label: '营业执照',
        img: true
      }, {
        prop: 'location',
        label: '地理位置'
      }, {
        prop: 'longitude',
        label: '经度'
      }, {
        prop: 'latitude',
        label: '纬度'
      }, {
        prop: 'remark',
        label: '备注'
      }, {
        prop: 'operation',
        label: '操作',
        width: '200px',
        fixed: 'right',
        operation: [{
          name: '视频',
          clickFun: row => handleViewVideo(row),
          hasPermi: ['Station:page:video']
        }, {
          name: '查看',
          clickFun: row => handleDetail(row),
          hasPermi: []
        }, {
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['Station:page:add']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['Station:page:del']
        }]
      }]
    });

    // 计算属性：获取有效的图片列表（过滤空值并添加前缀）
    const getImageList = computed(() => {
      if (!state.form.imgUrl || !Array.isArray(state.form.imgUrl)) {
        return [];
      }
      const prefix = window.g?.imgUrlPrex || '';
      return state.form.imgUrl.filter(img => img && img.trim() !== '').map(img => {
        const imgUrl = img.trim();
        // 如果URL已经是完整路径（以http://或https://开头），则不添加前缀
        if (imgUrl.startsWith('http://') || imgUrl.startsWith('https://')) {
          return imgUrl;
        }
        // 否则添加前缀
        return prefix + imgUrl;
      });
    });
    onMounted(() => {
      if (userType != 3) {
        state.uploadForm.tenantId = state.form.tenantId = window.localStorage.getItem("tenantId");
      }
    });
    /** 查询场站台账列表 */
    const getList = function () {
      state.loading = true;
      lgasStationList(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.records,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };

    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      reset();
    };
    const cancel = function () {
      state.open = false;
    };

    // 表单重置
    const reset = function () {
      state.form = {
        businessLicense: "",
        //营业执照
        commissioningDate: "",
        //投产日期	
        contactNumber: "",
        //联系方式	
        corporatePersion: "",
        //公司法人	
        latitude: "",
        //纬度		
        location: "",
        //地理位置
        longitude: "",
        //经度			
        operatorCompany: "",
        //运营公司	
        remark: "",
        //备注		
        tenantId: null,
        //	租户Id
        stationCode: "",
        //场站编码,场站编码长度为2-50个字符	
        stationName: "",
        //场站名称,场站名称长度为2-100个字符	
        imgUrl: [] //场站图片
      };
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        deviceCode: '',
        deviceName: '',
        deviceStatus: null,
        deviceTypeCode: '',
        imei: ''
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = '添加台账';
      state.isDetail = false;
      state.code = '';
      reset();
    };
    const clearValidate = prop => {
      deviceForm.value.clearValidate(prop);
    };

    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = '修改台账';
      state.form = {
        ...row
      };
      let imgList = state.form.businessLicense ? state.form.businessLicense.split(',') : [];
      state.form.businessLicense = imgList;
      let stationImgList = state.form.imgUrl ? Array.isArray(state.form.imgUrl) ? state.form.imgUrl : state.form.imgUrl.split(',') : [];
      state.form.imgUrl = stationImgList;
      state.isDetail = false;
      state.point = {
        lng: row.longitude,
        lat: row.latitude
      };
      state.openDataScope = true;
    };
    /** 修改/新增场站台账提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(deviceForm);
      formRef.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          if (Array.isArray(state.form.businessLicense)) {
            params.businessLicense = state.form.businessLicense.join(',');
          } else if (state.form.businessLicense) {
            params.businessLicense = String(state.form.businessLicense);
          } else {
            params.businessLicense = '';
          }
          if (state.form.imgUrl && Array.isArray(state.form.imgUrl) && state.form.imgUrl.length > 0) {
            params.imgUrl = state.form.imgUrl.join(',');
          } else {
            params.imgUrl = '';
          }
          if (state.form.id) {
            gasStationEdit(params).then(response => {
              if (response.code == 0) {
                ElMessage.success('修改成功');
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            gasStationAdd(params).then(response => {
              if (response.code == 0) {
                ElMessage.success('新增成功');
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    // 导入
    const downloadTemplate = function () {
      downloadFlie('/ty-iot-manage/api/v1/hanwei/device/exportTemplate');
    };
    const handleImport = function () {
      state.uploadForm.fileList = [];
      state.dialogVisible = true;
    };
    const closeUpload = function () {
      state.dialogVisible = false;
    };
    const handleRemove = function () {
      const formRef = unref(deviceForm);
      state.uploadForm.fileList = [];
      formRef.validate();
    };
    const uploadRef = ref(null);
    const submitUpload = function (formEl) {
      const upload = unref(uploadRef);
      formEl.validate(valid => {
        if (valid) {
          upload.submit();
        }
      });
    };
    const ruleFormRef = ref(null);
    const uploadChange = function (file, list) {
      const formRef = unref(ruleFormRef);
      const fileName = file.name.split('.').pop().toLowerCase();
      if (!['xlsx'].includes(fileName)) {
        state.uploadForm.fileList = [];
        ElMessage.warning('文件类型只支持xlsx格式！');
        formRef.validate();
        return;
      }
      state.uploadForm.fileList = [file];
      formRef.validate();
    };
    const uploadFile = function (params) {
      state.exportLoading = true;
      let formData = new FormData();
      formData.append('file', params.file);
      formData.append('tenantId', state.uploadForm.tenantId);
      importHwPage(formData).then(res => {
        state.saveLoading = false;
        state.exportLoading = false;
        state.dialogVisible = false;
        ElMessage.closeAll();
        if (res.code == 0) {
          if (res?.data?.code == 1001) {
            ElMessage.error(res?.data?.message);
          } else {
            ElMessage.success('导入成功！');
          }
          getList();
        } else {
          ElMessage.error(res.message);
        }
      }).catch(error => {
        ElMessage.closeAll();
        ElMessage.warning(error);
        state.saveLoading = false;
        state.exportLoading = false;
      });
    };
    const handleDetail = function (row) {
      state.title = '查看台账';
      state.form = {
        ...row
      };
      let imgList = state.form.businessLicense ? state.form.businessLicense.split(',') : [];
      state.form.businessLicense = imgList;
      let stationImgList = state.form.imgUrl ? Array.isArray(state.form.imgUrl) ? state.form.imgUrl : state.form.imgUrl.split(',') : [];
      state.form.imgUrl = stationImgList;
      state.isDetail = true;
      state.openDataScope = true;
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return deleteGasStation(roleIds);
      }).then(res => {
        getList();
        ElMessage.success('删除成功');
      }).catch(function () {});
    };

    /** 查看视频按钮操作 */
    const handleViewVideo = function (row) {
      state.videoDialogVisible = true;
      state.videoLoading = true;
      state.videoList = [];
      state.currentVideoIndex = 0;

      // 调用接口获取场站视频
      getStationVideos(row.id).then(response => {
        if (response.code == 0 && response.data && response.data.length > 0) {
          state.videoList = response.data;
          // 测试第一个视频 URL 是否可访问
          const firstVideo = state.videoList[0];
          // 等待DOM更新后初始化播放器
          nextTick(() => {
            initVideoPlayer();
            state.videoLoading = false;
          });
        } else {
          state.videoList = [];
          state.videoLoading = false;
        }
      }).catch(error => {
        state.videoList = [];
        state.videoLoading = false;
      });
    };

    /** 初始化视频播放器 */
    const initVideoPlayer = function () {
      console.log('videoPlayer.value', videoPlayer.value);
      console.log('videoList', state.videoList);

      // 销毁已存在的 HLS 实例
      if (state.hlsInstance) {
        state.hlsInstance.destroy();
        state.hlsInstance = null;
      }
      if (!videoPlayer.value) {
        setTimeout(() => {
          initVideoPlayer();
        }, 100);
        return;
      }
      if (state.videoList.length > 0 && videoPlayer.value) {
        const currentVideo = state.videoList[state.currentVideoIndex];
        console.log('当前视频信息:', currentVideo);
        console.log('视频URL:', currentVideo.url);
        const video = videoPlayer.value;
        // 检查浏览器是否支持 HLS
        if (Hls.isSupported()) {
          try {
            state.hlsInstance = new Hls({
              debug: false,
              enableWorker: true,
              lowLatencyMode: false,
              backBufferLength: 90,
              maxBufferLength: 30,
              maxMaxBufferLength: 600,
              xhrSetup: function (xhr, url) {
                console.log('XHR 请求:', url);
                // 如果需要跨域凭证，取消注释下一行
                // xhr.withCredentials = true
              }
            });
            // 绑定媒体元素
            state.hlsInstance.attachMedia(video);
            // 监听媒体附加成功事件
            state.hlsInstance.on(Hls.Events.MEDIA_ATTACHED, function () {
              // 加载视频源
              state.hlsInstance.loadSource(currentVideo.url);
            });

            // 监听清单加载完成
            state.hlsInstance.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
              // 自动播放视频（静音模式）
              nextTick(() => {
                // 确保视频处于静音状态以符合自动播放策略
                video.muted = true;
                video.play().then(() => {}).catch(err => {
                  video.muted = false;
                });
              });
            });

            // 监听片段加载完成
            state.hlsInstance.on(Hls.Events.FRAG_LOADED, function (event, data) {
              console.log('✅视频加载完成');
            });

            // 监听错误
            state.hlsInstance.on(Hls.Events.ERROR, function (event, data) {
              console.error('失败:', data);
              if (data.fatal) {
                switch (data.type) {
                  case Hls.ErrorTypes.NETWORK_ERROR:
                    ElMessage.warning('网络错误，正在尝试重新连接...');
                    setTimeout(() => {
                      if (state.hlsInstance) {
                        state.hlsInstance.startLoad();
                      }
                    }, 1000);
                    break;
                  case Hls.ErrorTypes.MEDIA_ERR:
                    ElMessage.warning('媒体错误，正在尝试恢复...');
                    if (state.hlsInstance) {
                      state.hlsInstance.recoverMediaError();
                    }
                    break;
                  default:
                    ElMessage.error('视频播放失败: ' + (data.details || data.type));
                    if (state.hlsInstance) {
                      state.hlsInstance.destroy();
                      state.hlsInstance = null;
                    }
                    break;
                }
              }
            });
            video.addEventListener('error', function (e) {
              if (video.error) {
                // 提供更友好的错误信息
                let errorMsg = '视频加载失败';
                switch (video.error.code) {
                  case 1:
                    errorMsg = '视频加载被中止';
                    break;
                  case 2:
                    errorMsg = '网络错误，无法加载视频';
                    break;
                  case 3:
                    errorMsg = '视频解码失败';
                    break;
                  case 4:
                    errorMsg = '视频格式不支持或视频源不可用';
                    break;
                }
              }
            });
          } catch (error) {
            ElMessage.error('初始化播放器失败: ' + error.message);
          }
        } else {
          ElMessage.error('您的浏览器不支持 HLS 视频播放，请使用 Chrome、Firefox 或 Safari 浏览器');
        }
      }
    };

    /** 切换视频 */
    const switchVideo = function (index) {
      if (state.currentVideoIndex === index) return;
      state.currentVideoIndex = index;
      const video = videoPlayer.value;
      const currentVideo = state.videoList[index];
      if (!currentVideo || !video) {
        console.error('视频不存在');
        return;
      }

      // 1. 先暂停并清空当前视频
      video.pause();
      video.currentTime = 0;
      video.src = ''; // 清空 video 元素的 src

      // 2. 完全销毁旧的 HLS 实例（关键！）
      if (state.hlsInstance) {
        state.hlsInstance.destroy();
        state.hlsInstance = null;
      }

      // 3. 重新创建 HLS 实例并加载新视频
      if (Hls.isSupported()) {
        try {
          state.hlsInstance = new Hls({
            debug: false,
            enableWorker: true,
            lowLatencyMode: false,
            backBufferLength: 90,
            maxBufferLength: 30,
            maxMaxBufferLength: 600
          });

          // 绑定媒体元素
          state.hlsInstance.attachMedia(video);

          // 监听媒体附加成功事件
          state.hlsInstance.on(Hls.Events.MEDIA_ATTACHED, function () {
            state.hlsInstance.loadSource(currentVideo.url);
          });

          // 监听清单加载完成
          state.hlsInstance.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
            nextTick(() => {
              video.muted = true;
              video.play().then(() => {}).catch(err => {
                video.muted = false;
              });
            });
          });

          // 监听错误
          state.hlsInstance.on(Hls.Events.ERROR, function (event, data) {
            if (data.fatal) {
              switch (data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                  ElMessage.warning('网络错误，正在尝试重新连接...');
                  setTimeout(() => {
                    if (state.hlsInstance) {
                      state.hlsInstance.startLoad();
                    }
                  }, 1000);
                  break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                  ElMessage.warning('媒体错误，正在尝试恢复...');
                  if (state.hlsInstance) {
                    state.hlsInstance.recoverMediaError();
                  }
                  break;
                default:
                  ElMessage.error('视频播放失败: ' + (data.details || data.type));
                  break;
              }
            }
          });
        } catch (error) {
          console.error('创建 HLS 实例失败:', error);
          ElMessage.error('切换视频失败: ' + error.message);
        }
      } else {
        ElMessage.error('您的浏览器不支持 HLS 视频播放');
      }
    };

    /** 关闭视频对话框 */
    const closeVideoDialog = function () {
      // 暂停视频
      if (videoPlayer.value) {
        videoPlayer.value.pause();
      }

      // 销毁 HLS 实例
      if (state.hlsInstance) {
        state.hlsInstance.destroy();
        state.hlsInstance = null;
      }
      state.videoList = [];
      state.currentVideoIndex = 0;
      state.videoLoading = false;
    };

    // 组件卸载前清理播放器
    onBeforeUnmount(() => {
      if (state.hlsInstance) {
        state.hlsInstance.destroy();
        state.hlsInstance = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_EIUploadOnePic = _resolveComponent("EIUploadOnePic");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_image = _resolveComponent("el-image");
      const _component_EIUploadMutiplePic = _resolveComponent("EIUploadMutiplePic");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, _ctx.form),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => state.openDataScope = $event),
        size: "550px",
        title: state.title,
        "close-on-click-modal": false,
        disabled: state.isDetail,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [!state.isDetail ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
          disabled: state.isDetail,
          model: state.form,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "deviceForm",
          ref: deviceForm,
          rules: state.rules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所属租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.tenantId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.form.tenantId = $event),
                  placeholder: "请选择所属租户"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.tenantName,
                      value: item.tenantId,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "场站编码",
                prop: "stationCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.stationCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.form.stationCode = $event),
                  disabled: !!state.form.id,
                  placeholder: "请输入场站编码最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "场站名称",
                prop: "stationName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.stationName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.form.stationName = $event),
                  placeholder: "请输入场站名称最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "营业执照",
                prop: "businessLicense"
              }, {
                default: _withCtx(() => [_createVNode(_component_EIUploadOnePic, {
                  "file-list": state.form.businessLicense,
                  "onUpdate:fileList": _cache[4] || (_cache[4] = $event => state.form.businessLicense = $event),
                  onClearValidate: _cache[5] || (_cache[5] = $event => clearValidate(state.form.businessLicense))
                }, null, 8, ["file-list"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "运营公司",
                prop: "operatorCompany"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.operatorCompany,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.form.operatorCompany = $event),
                  placeholder: "请输入运营公司最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "公司法人",
                prop: "corporatePersion"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.corporatePersion,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.form.corporatePersion = $event),
                  placeholder: "请输入公司法人最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "联系人",
                prop: "contactPerson"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.contactPerson,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => state.form.contactPerson = $event),
                  placeholder: "请输入联系人最多10个字符",
                  maxlength: "10",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "联系方式",
                prop: "contactNumber"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.contactNumber,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.form.contactNumber = $event),
                  placeholder: "请输入联系方式"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "员工数量",
                prop: "employeeNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: state.form.employeeNum,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.form.employeeNum = $event),
                  min: 0,
                  max: 100,
                  placeholder: "请输入员工数量",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "投产日期",
                prop: "commissioningDate"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: state.form.commissioningDate,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => state.form.commissioningDate = $event),
                  type: "date",
                  placeholder: "请选择投产日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "地理位置",
                prop: "location"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.location,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => state.form.location = $event),
                  placeholder: "请输入地理位置最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "经度",
                prop: "longitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.longitude,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => state.form.longitude = $event),
                  placeholder: "请输入经度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "纬度",
                prop: "latitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.latitude,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => state.form.latitude = $event),
                  placeholder: "请输入纬度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "场站图片",
                prop: "imgUrl"
              }, {
                default: _withCtx(() => [state.isDetail ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getImageList), (img, index) => {
                  return _openBlock(), _createBlock(_component_el_image, {
                    key: index,
                    src: img,
                    "preview-src-list": _unref(getImageList),
                    "initial-index": index,
                    fit: "cover",
                    class: "preview-image",
                    "preview-teleported": true
                  }, null, 8, ["src", "preview-src-list", "initial-index"]);
                }), 128)), !_unref(getImageList) || _unref(getImageList).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(_component_EIUploadMutiplePic, {
                  key: 1,
                  "file-list": state.form.imgUrl,
                  "onUpdate:fileList": _cache[15] || (_cache[15] = $event => state.form.imgUrl = $event),
                  limit: 3,
                  onClearValidate: _cache[16] || (_cache[16] = $event => clearValidate(state.form.imgUrl)),
                  uploadTip: "最多上传3张图片"
                }, null, 8, ["file-list"]))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.remark,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => state.form.remark = $event),
                  placeholder: "请输入备注最多200个字符",
                  type: "textarea",
                  rows: 3,
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled", "model", "rules"])])]),
        _: 1
      }, 8, ["modelValue", "title", "disabled"]), _createVNode(_component_commonDrawer, {
        title: "导入设备",
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => state.dialogVisible = $event),
        width: "500px",
        "close-on-click-modal": false,
        "before-close": closeUpload
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[20] || (_cache[20] = $event => submitUpload(ruleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: closeUpload
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "auto-upload": false,
          model: state.uploadForm,
          rules: state.uploadFormRules,
          "status-icon": "",
          "label-width": "120px",
          class: "commonForm"
        }, {
          default: _withCtx(() => [_hoisted_10, _unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属租户",
              prop: "tenantId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: state.uploadForm.tenantId,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => state.uploadForm.tenantId = $event),
                placeholder: "请选择所属租户"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.tenantName,
                    value: item.tenantId,
                    key: index
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "模板"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadTemplate
            }, {
              default: _withCtx(() => [_createTextVNode("下载模板")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文件",
            prop: "fileList"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              "auto-upload": false,
              class: "upload-demo",
              action: "",
              "on-remove": handleRemove,
              "file-list": state.uploadForm.fileList,
              "on-change": uploadChange,
              "http-request": uploadFile
            }, {
              tip: _withCtx(() => [_hoisted_11]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("上传文件")]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: state.videoDialogVisible,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => state.videoDialogVisible = $event),
        title: "场站视频",
        width: "1000px",
        "close-on-click-modal": false,
        onClose: closeVideoDialog
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [!state.videoLoading && state.videoList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.videoList, (video, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["video-item", {
              'active': state.currentVideoIndex === index
            }]),
            onClick: $event => switchVideo(index)
          }, [_hoisted_17, _createElementVNode("span", null, _toDisplayString(video.name), 1)], 10, _hoisted_16);
        }), 128))]), _createElementVNode("div", _hoisted_18, [_createElementVNode("video", {
          ref_key: "videoPlayer",
          ref: videoPlayer,
          id: "videoPlayer",
          class: "video-player",
          controls: "",
          preload: "auto",
          playsinline: "",
          "webkit-playsinline": "",
          "x5-playsinline": "",
          muted: "",
          crossorigin: "anonymous"
        }, " 您的浏览器不支持视频播放 ", 512)])])) : !state.videoLoading && state.videoList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_empty, {
          description: "该场站暂无视频"
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        })])) : _createCommentVNode("", true)])), [[_directive_loading, state.videoLoading]])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, state.exportLoading]]);
    };
  }
};